import React from "react";
import {MealForecastApp} from "../Functionality/MealForecastApp";
import NotInformation from "../../../../../components/NotInformation";
import MealForecastCard from "./MealForecastCard";
import {CustomSelect} from "../../../../../components/CustomSelect";
import {CustomDateRangePicker} from "../../../../../components/CustomDateRangePicker";
/**
 * Visual component that consumes the MealForecastApp logic hook
 * to render cafeteria and date range filters, and display the
 * corresponding meal forecast results.
 *
 * @Email   : kpozos@ibl.mx
 * @Author  : Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer
 *
 * @param {Object} props - Component properties.
 * @param {Function} props.t - Translation function (i18n).
 * @param {Array<Object>} props.results - List of meal forecast results to render.
 *
 * @returns {JSX.Element} Rendered component for meal forecast view.
 */
const MealForecast = (props) => {
    const { t, results, setResults, setBodyForExport } = props;
    const {
        cafeteriasOptions,
        data,
        setData,
        handleChange
    } = MealForecastApp({
            setResults,
            setBodyForExport
        });

    return (
        <>
            <div className={"row mt-3"}>
                <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 pl-sm-0 pr-sm-0 pl-md-0 pr-md-2 pl-xl-0 pr-xl-2"}>
                    <CustomSelect
                        disabled={false}
                        id={"slt_mf_cafeteria_id"}
                        list={cafeteriasOptions || []}
                        name={"cafeteriaId"}
                        onChange={handleChange}
                        emptyFields={false}
                        required={true}
                        trans={"diner"}
                        value={data.cafeteriaId || ''}
                        showNoSelectionOption={false}
                        keyName="id"
                        helperText={data.cafeteriaId ? "" : t("select_a_cafeteria")}
                    />
                </div>
                <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 pl-sm-0 pr-sm-0 pl-md-2 pr-md-0 pl-xl-2 pr-xl-0"}>
                    <CustomDateRangePicker
                        id={'dp_mf_date_range'}
                        name={'dateRange'}
                        disabled={false}
                        trans={'date_range'}
                        rangeData={data}
                        setRangeDate={setData}
                        required={true}
                    />
                </div>
            </div>
            <div className="panelTables mt-4">
                {!Array.isArray(results) || results.length === 0 ? (
                    <NotInformation text={t('meals_for_this_period_have_not_yet_been_defined')} card={true} />
                ) : (
                    results?.reduce((rows, item, index) => {
                        if (index % 2 === 0) rows.push([]);
                        rows[rows.length - 1].push(item);
                        return rows;
                    }, []).map((row, rowIndex) => (
                        <div className="row" key={rowIndex}>
                            {row.map((item, colIndex) => (
                                <div key={colIndex} className="col-sm-12 col-md-6 mb-3 d-flex">
                                    <MealForecastCard item={item} />
                                </div>
                            ))}
                        </div>
                    ))
                )}
            </div>
        </>
    );
};

export default MealForecast;
